import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { NgChartsModule, ThemeService } from 'ng2-charts'
import { SharedModule } from 'src/app/shared/shared.module'
import { DashboardComponent } from './dashboard.component'
import { dashboardRoutes } from './dashboard.routing'
import { NgxPermissionsModule } from 'ngx-permissions'

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(dashboardRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    NgChartsModule,
    NgxPermissionsModule,
  ],
  exports: [DashboardComponent],
  providers: [ThemeService],
})
export class DashboardModule {}
